import React, { useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import { HeaderStyle } from "../../Common/styles/header";
import {
  a11yProps,
  MainTabPanel,
  StyledTab,
  StyledTabs,
} from "../../Common/UI/TabPanel";
import { useSearchParams } from "react-router-dom";
import { v4 as uuid } from "uuid";
import EConsentList from "../../EConsent/EConsentList";

const ConsentTabs = () => {
  const [type, setType] = useState<string>("consent");

  const [searchParams, setSearchParams] = useSearchParams();
  const [searchText, setSearchText] = useState(
    searchParams.get("search") || ""
  );
  const [searchId, setSearchId] = useState(uuid());
  const [page, setPage] = useState(parseInt(searchParams.get("page") || "0"));

  const dataEditable = true;

  useEffect(() => {
    const params = new URLSearchParams();
    params.set("type", type);
    params.set("page", page.toString());

    if (searchText) {
      params.set("search", searchText);
    }

    setSearchParams(params, {
      replace: true,
    });
  }, [setSearchParams, page, searchText, type]);

  const handleChange = (_: any, newValue: string) => {
    setType(newValue);
    setPage(0);
    setSearchId(uuid());
    setSearchText("");
  };

  return (
    <>
      <Box sx={HeaderStyle}>
        <Typography variant="h2" color="text.primary">
          Consent
        </Typography>
      </Box>
      {/* <Box sx={{ borderBottom: 1, borderColor: "#E5E7EB" }}>
        <StyledTabs value={type} onChange={handleChange}>
          <StyledTab label="Consent" value="consent" {...a11yProps(0)} />
          <StyledTab
            label="Sunshine Forms"
            value="sunshine"
            {...a11yProps(1)}
          />
        </StyledTabs>
      </Box> */}
      <Box
        sx={{
          borderTop: 1,
          borderColor: "#E5E7EB",
          borderBottom: "1px solid #E5E7EB",
          height: "calc(100vh - 132px)",
          overflow: "hidden",
          p: 2.5,
        }}
      >
        {/* <MainTabPanel value={type} index={type}> */}
        <EConsentList
          formType={type as "consent" | "sunshine"}
          page={page}
          setPage={setPage}
          searchText={searchText}
          setSearchText={setSearchText}
          searchId={searchId}
          setSearchId={setSearchId}
          canEdit={dataEditable}
          type="platform"
        />
        {/* </MainTabPanel> */}
      </Box>
    </>
  );
};

export default ConsentTabs;
